import React from 'react';
import cx from 'classnames';
import { FaceHappyIcon } from '@THC/components/Icons';

import Drawer from 'Storybook/core/Drawer/Drawer';
import { Variant } from 'Types/variant';

import styles from './VideoModal.module.scss';

export type VideoModalProps = {
	dismissModal: () => void;
	youtubeVideoId: string;
};

export type VideoModalContentProps = Pick<VideoModalProps, 'youtubeVideoId'> & {
	autoplay?: boolean;
};

export const VideoModalContent: React.FC<VideoModalContentProps> = ({ autoplay = true, youtubeVideoId }) => (
	<div className={cx(styles.videoContainer, styles.center)}>
		<div className={cx(styles.videoAR)}>
			<iframe
				allowFullScreen
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				data-chromatic="ignore"
				height="100%"
				loading="lazy"
				src={youtubeVideoId ? `https://www.youtube.com/embed/${youtubeVideoId}?${autoplay ? 'autoplay=1' : ''}` : ''}
				style={{ border: 'none' }}
				title="Introducing Motorway Move"
				width="100%"
			></iframe>
			<FaceHappyIcon data-thc-icon />
		</div>
	</div>
);

export const VideoModal: React.FC<VideoModalProps> = ({ dismissModal, youtubeVideoId }) => {
	return (
		<Drawer
			isOpen
			className={styles.drawer}
			direction="bottom"
			onClose={dismissModal}
			size="full"
			title="Introducing Motorway Move"
			variant={Variant.SECONDARY}
		>
			<VideoModalContent youtubeVideoId={youtubeVideoId} />
		</Drawer>
	);
};
